import request from '@/utils/request'
import type { ApiResponse, MenuResponse, StandardForm } from '@/types/menu'


// 获取标准详情
export const getStandardById = (id: string | number) => {
  return request({
    url: `/common/standard/${id}`,
    method: 'get'
  })
}


// 定义查询参数接口
interface TermQueryParams {
  standardId:  string;
}

// 根据标准ID获取术语列表
export function getTermsByStandardId(standardId:number) {
  return request<{
    code: number;
    msg: string | null;
    data: Array<{
      id: string;
      standardId: string;
      cName: string;
      eName: string;
      explanation: string;
      image: string;
    }>
  }>({
    url: `/admin/term/byStandardId`,
    method: 'get',
    params: { id: standardId }
  })
}

export function getLevelDetail(id: string, level: number) {
  if (!id || typeof level !== 'number') {
    return Promise.reject(new Error('指标参数不完整'))
  }
  
  return request({
    url: `/admin/level/${id}`,
    method: 'get',
    params: {
      level
    },
    validateStatus: function (status) {
      return status >= 200 && status < 300
    }
  })
}

// 新增术语接口
export const addTerm = (data: {
  standardId: number;
  cName: string;
  eName?: string;
  explanation?: string;
  imageList?: string[];
}) => {
  return request({
    url: '/admin/term',
    method: 'post',
    data
  });
};

export const uploadImage = (file: File) => {
  const formData = new FormData();
  formData.append('file', file);
  
  return request({
    url: '/common/image',
    method: 'post',
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    data: formData
  });
};

// 获取标准列表的请求参数接口
export interface StandardListRequest {
  key?: string | null;          // 关键词，用于模糊查询
  page: number;          // 当前页码
  pageSize: number;      // 每页条数
  type?: string | null;         // 级别分类【国家、地方、企业】
}



// 接口返回数据结构需要包含以下字段
interface StandardItem {
  standardName: string
  standardNumber: string
  responsibleUnit: string
  departmentName: string
  draftAuthor: string
  draftUnit: string
  level: string
  image?: string
  // ...其他字段
}

interface StandardResponse {
  code: number;
  msg: string | null;
  data: {
    total: number;
    record: StandardItem[];
  };
}
// 新增文件上传接口
export const uploadFileWithParams = (data: {
  id?: number | null
  file: string
  standardId?: number
  fileName?: string
}) => {
  return request({
    url: '/admin/file',
    method: 'post',
    data
  })
}

  // 更新标准 - 修改函数签名，分别接收 id 和数据
  export function updateFile(data: {
    id?: number
    file?: string
    standardId?: number
    fileName?: string
  }) {
    return request({
      url: `/admin/file`, // 使用模板字符串正确拼接 id
      method: 'put',
      data
    })
  }




